import React from 'react';
export function Features() {
  const features = [{
    iconUrl: 'https://cdn.magicpatterns.com/uploads/e93H5G76CfiPPJQQb1UZvM/no-coding-required.png',
    title: 'No Coding Required',
    description: 'Create games without writing a single line of code using our AI'
  }, {
    iconUrl: 'https://cdn.magicpatterns.com/uploads/hKeyVxVxv5ymvpT5jDqYoY/remix-anything.png',
    title: 'Remix Anything',
    description: 'Transform any game into your own unique creation in minutes'
  }, {
    iconUrl: 'https://cdn.magicpatterns.com/uploads/qVRvgd1BuZAq2z9u8Yvv3Q/customize-everything.png',
    title: 'Customize Everything',
    description: 'Change themes, rules, and visuals to match your vision'
  }, {
    iconUrl: 'https://cdn.magicpatterns.com/uploads/udMWJZyJb5qjJeYpwHpKWf/community-driven.png',
    title: 'Community Driven',
    description: 'Join our community of creators sharing new games everyday'
  }, {
    iconUrl: 'https://cdn.magicpatterns.com/uploads/tr6a7FVXR3dEL7W6hKPVNT/instantly-playable.png',
    title: 'Instantly Playable',
    description: 'Test and play your creations immediately as you build'
  }, {
    iconUrl: 'https://cdn.magicpatterns.com/uploads/mjyM3fCDMVv8ZqhayPqDJE/share-and-publish.png',
    title: 'Share & Publish',
    description: 'Publish your games and share them with the world in one click'
  }];
  return <div className="w-full relative" style={{
    backgroundColor: '#074030'
  }} data-id="element-27">
      {/* Noise texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
      backgroundRepeat: 'repeat',
      backgroundSize: '200px 200px',
      opacity: 0.24
    }} data-id="element-28" />

      {/* Content */}
      <div className="relative z-10" data-id="element-29">
        <section className="w-full px-10 md:px-32 pt-20 pb-9 lg:pt-28 lg:pb-12" data-id="element-30">
          <div className="max-w-6xl mx-auto" data-id="element-31">
            <div className="text-center mb-8" data-id="element-32">
              <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{
              color: 'white',
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-33">
                Everything you need to create
              </h2>
              <p className="text-xl" style={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-34">
                Powerful tools designed for creators of all skill levels
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-8 pb-40" data-id="element-35">
          <div className="max-w-6xl mx-auto" data-id="element-36">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-37">
              {features.map((feature, index) => <div key={index} className="p-8 rounded-2xl" style={{
              backgroundColor: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }} data-id="element-38">
                  <img src={feature.iconUrl} alt={feature.title} className="w-8 h-8 mb-6" style={{
                filter: 'brightness(0) invert(1)'
              }} data-id="element-39" />
                  <h3 className="font-medium mb-3" style={{
                color: 'white',
                fontFamily: "'Instrument Sans', sans-serif",
                fontSize: '19px'
              }} data-id="element-40">
                    {feature.title}
                  </h3>
                  <p className="text-[16px] md:text-[15px]" style={{
                color: 'rgba(255, 255, 255, 0.6)',
                lineHeight: '1.6',
                fontFamily: "'Instrument Sans', sans-serif"
              }} data-id="element-41">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>
      </div>
    </div>;
}